module.exports = __webpack_public_path__ + "static/media/i-am-that-i-am.ba6657c6.txt";